import { useCallback, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Email } from "@mui/icons-material";

const useHttp = (requestConfig, applyData) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { getAccessTokenSilently, loginWithRedirect, user, logout } = useAuth0();

  const sendRequest = useCallback(async (requestConfig, applyData) => {
    setIsLoading(true);
    setError(null);

    const token = await getAccessTokenSilently();

    try {
      const headers = requestConfig.isFileUpload
        ? {
            Authorization: `Bearer ${token}`,
            "X-Email": user?.email || "",
            ...requestConfig.headers,
        }
        : {
            "Content-type": "application/json; charset=utf-8",
            Authorization: `Bearer ${token}`,
            "X-Email": user?.email || "",
            ...requestConfig.headers,
          };

      const response = await fetch(requestConfig.url, {
        method: requestConfig.method ? requestConfig.method : "GET",
        headers: headers,
        body: requestConfig.body
          ? requestConfig.isFileUpload === true
            ? requestConfig.body
            : JSON.stringify(requestConfig.body)
          : null,
      });

      if (!response.ok) {
        if (response.status === 401) {
          logout();
        }
        const responseData = await response.json();
        setError(responseData.detail || "Request failed.");
        throw new Error(responseData.detail || "Request failed.");
      }

      let data = null;

      if(response.status !== 204){
        data = await response.json();
      } 

      applyData(data);
    } catch (err) {
      setError(err.message || "Something went wrong.");
    }
    setIsLoading(false);
  }, []);

  return {
    isLoading,
    error,
    sendRequest,
  };
};

export default useHttp;
